export default "__VITE_ASSET__BEa5$Inr__"